import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import React from 'react'

const Form = React.lazy(() => import('../../components/Form'))
const FormItem = React.lazy(() => import('../../components/Form/FormItem'))
const Button = React.lazy(() => import('../../components/General/Button'))
const InputText = React.lazy(() => import('../../components/Inputs/InputText'))

const EditCompoundForm = ({
  defaultValues,
  onCancel,
  onSubmitForm,
  isAssembly = false,
}) => {
  const form = useForm<any>({
    defaultValues: { ...defaultValues },
  })

  useEffect(() => {
    console.log('VER VALUES', defaultValues)
  }, [defaultValues])

  return (
    <>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        onSubmit={(values) => onSubmitForm(values)}
      >
        <FormItem
          name={isAssembly ? `productionItem.name` : `name`}
          classes="col-span-9"
          rules={{
            required: 'Es necesario el código del lote',
          }}
        >
          <InputText
            small
            label="Articulo"
            maxLength={80}
            disableInput={true}
          />
        </FormItem>

        <FormItem
          name={!isAssembly ? "amount" : "productionItem.requiredQuantity"}
          classes="col-span-3"
          rules={{
            required: 'Es necesario el código del lote',
          }}
        >
          <InputText small label="Cantidad" maxLength={80} />
        </FormItem>

        <div className="col-start-2 col-span-9 flex space-x-2 mt-4 px-1 mt-3">
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => onCancel()}
            htmlType="button"
          >
            Cancelar
          </Button>

          <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
            Guardar
          </Button>
        </div>
      </Form>
    </>
  )
}

export default EditCompoundForm
